'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/dom-helpers/util/hyphenate.js
// module id = 1124
// module chunks = 6